module.exports = __webpack_public_path__ + "media/great.6092792e.mp3";